import { Component } from '@angular/core';
import { LandingDesignBase } from '../landing-design-base';

// Diseño 1 de landing: cabecera, instrucciones + banner, pestañas por sección y cards de formularios.
@Component({
  selector: 'app-landing-design-1',
  templateUrl: './landing-design-1.component.html',
  styleUrls: ['./landing-design-1.component.scss'],
})
export class LandingDesign1Component extends LandingDesignBase {}
